var exports = {
  "R4": "DialogBody__Uam2dv",
  "Ru": "CreateDialog__Io2vF4",
  "Dr": "CreateDialogHasBanner__PNoKy8",
  "lV": "Form__hNjkQ2",
  "TM": "Textarea__75CM8P",
  "vZ": "TitleButton__vaahaw",
  "a1": "TitleText__5Nhu8M",
  "cf": "TitlePencil__-Cibt7",
  "t3": "TitleInput__yZmIdc",
};

module.exports = exports;
